<template>
  <exo-help-dialog margin="m-0" title="Duty cycles">
    The duty cycles represent the fraction of time for which a system is active.
    Some definitions are given below:
    <ul>
      <li>
        <strong>Orbital duty cycle</strong> : fraction of an orbit for which the
        propulsion system is thrusting;
      </li>
      <li>
        <strong>Mean duty cycle</strong> : fraction of a maneuver cycle for
        which the propulsion system is thrusting;
      </li>
      <li>
        <strong>Warm-up mean duty cycle</strong> : fraction of a maneuver cycle
        for which the propulsion system is warming up.
      </li>
    </ul>

    <br />
    The values presented on the dashboard represent:
    <ul>
      <li>
        <strong>Dynamic duty cycle</strong> : denotes if the dynamic duty cycle
        is simulated, which updates the duty cycle as the eclipse time varies
        within the simulation;
      </li>
      <li>
        <strong>Spacecraft definition duty cycle</strong> : value of
        <i>orbital duty cycle</i> selected in the spacecraft definition. May not
        be the value of <i>orbital duty cycle</i> used in the simulation, in the
        case it results in a <i>mean duty cycle</i> greater than
        <i>max mean duty cycle</i>;
      </li>
      <li>
        <strong>Initial warm-up mean duty cycle</strong> :
        <i>warm-up mean duty cycle</i> calculated considering that the maneuver
        cycle consists on one or more orbits identical to the initial orbit.
        Used in the calculation of <i>max mean duty cycle</i>;
      </li>
      <li>
        <strong>Orbital duty cycle</strong> : value of
        <i>orbital duty cycle</i> used in the simulation;
      </li>
      <li>
        <strong>Max mean duty cycle</strong> : maximum value of the
        <i>mean duty cycle</i> possible, calculated based on the spacecraft
        on-board average power, on the propulsion system thruster, stand-by and
        warm-up powers and on the <i>warm-up mean duty cycle</i>.
      </li>
    </ul>
  </exo-help-dialog>
</template>

<script>
export default {
  name: 'tooltipNumericalDutyCycles'
}
</script>
